import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage();
const titlePlaceholder = computed(() => page.props.titlePlaceholder);

export function useTitle(message = '') {
    return titlePlaceholder.value?.replace('{title}', message);
}
